module.exports = __webpack_public_path__ + "static/calgary-foundation-b3512e7a2d489165934b3e75f6502b7f.png";